<div class="wrapper">
    <div class="left-block">
        <app-tab-dashboard-bom-left-block></app-tab-dashboard-bom-left-block>
    </div>
    <div class="right-block">
        <app-tab-dashboard-bom-right-block></app-tab-dashboard-bom-right-block>
    </div>
</div>